<template>
  <div class="scpPage">
    <div class="operation">
      <div>
      <i-button @click="scpConfig">
        <i class="iconfont icon-refresh"></i>
        刷新
      </i-button>
      <i-button @click="showLog = true" style="margin-left: 15px;" type="primary">
        查看日志
      </i-button>
    </div>
      <div style="display: flex;align-items: center;">
      <i-switch
          v-model="isOpen"
          @on-change="changeSwitch"
          size="small"
          style="margin: 8px 20px 0 0px"
        ></i-switch>
      <div class="status">
        {{
          result.serviceStatus == 10
            ? "启 用"
            : result.serviceStatus == 11
            ? "启 用 中"
            : result.serviceStatus == 21
            ? "禁 用 中"
            : "禁 用"
        }}
      </div>
    </div>
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        C-Store SCP服务基本信息
        <Poptip
          content="远程服务器和本地医疗设备的连接服务"
          placement="right"
          class="tip"
          trigger="hover"
          style="margin-left: 10px;"
        >
        <Icon type="md-alert" />
        </Poptip>
      </div>
      <!-- <div style="display: flex; justify-content: space-between">
     
      
      </div> -->
    </div>
    <div class="des">
      <div class="serDes">
        <span class="secondTit">服务描述：</span>{{ result.description }}
      </div>
      <!-- <div>
        <span class="secondTit">更新时间：</span>{{ result.updateTime }}
      </div> -->
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        基础配置
      </div>
    </div>
    <div class="des">
      <Form :label-width="150" inline>
        <FormItem label="影像存储路径">
          <Input
            placeholder="请输入"
            v-model="baseData.rootPath"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="是否打印SQL">
          <Radio-group v-model="baseData.isPrintSql">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </Radio-group>
        </FormItem>
        <!-- <FormItem label="是否脱敏">
          <Radio-group v-model="baseData.isDesensitization">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </Radio-group>
        </FormItem> -->
        <FormItem label="日志级别">
          <Select v-model="baseData.logLevel" style="width: 190px">
            <Option
              v-for="item in LogsData"
              :value="item.key"
              :key="item.key"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <Button class="ml-5 mr-5" type="primary" @click="updateScpBaseConfig"
        >确定</Button
      >
      <Button @click="cancelEdit">重置</Button>
      <div></div>
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        redis设置参数
      </div>
    </div>
    <div class="des">
      <Form :label-width="120">
        <FormItem label="redis设置参数">
          <Select v-model="redisIndex" style="width: 200px">
            <Option v-for="item in redisPrice" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </FormItem>
      </Form>
      <Button class="ml-5 mr-5" type="primary" @click="redisSet">确定</Button>
      <Button @click="RedisEdit">重置</Button>
    </div>

    <div class="listenList">
      <div class="right">
        <div class="tit">
          <div class="line"></div>
          监听列表
        </div>
        <Table
          border
          highlight-row
          :columns="columnsOne"
          :data="data.ListenPortList"
        ></Table>
        <div class="tip">
          监听列表默认情况下只需要添加一个端口监听即可，默认配置为设备能够和本机指定静态IP的端口通信的配置信息
        </div>
      </div>
      <div class="left">
        <div class="tit">
          <div class="line"></div>
          编辑监听参数
        </div>
        <div class="contain">
          <Form :label-width="69">
            <FormItem label="默认IP">
              <Input
                placeholder="请输入"
                v-model="paramsListen.IPAddress"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="监听端口">
              <Input
                placeholder="请输入"
                v-model="paramsListen.Port"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="本地AE">
              <Input
                placeholder="请输入"
                v-model="paramsListen.AE"
                clearable
              ></Input>
            </FormItem>
          </Form>
        </div>
        <div class="btnGroup">
          <Button class="cancel" @click="clear('listen')">重置</Button>
          <Button type="primary" @click="addOrEidt('listen', 'save')">{{
            btnName
          }}</Button>
        </div>
      </div>
     
    </div>
    <div class="listenList">
     
      <div class="right">
        <div class="tit">
          <div class="line"></div>
          AE列表
        </div>
        <Table
          border
          highlight-row
          :columns="columns"
          :data="data.AeList"
        ></Table>
        <div class="tip">
          AE列表为设备的请求信息，设备AE可以相同，但是设备IP不能重复；设备IP重复，AE必须不同；一般情况下设备IP都是静态IP不会重复
        </div>
      </div>
      <div class="left">
        <div class="tit">
          <div class="line"></div>
          编辑请求节点参数
        </div>
        <div class="contain">
          <Form :label-width="69">
            <FormItem label="请求IP">
              <Input
                placeholder="请输入"
                v-model="paramsAE.IP"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="请求AE">
              <Input
                placeholder="请输入"
                v-model="paramsAE.AE"
                clearable
              ></Input>
            </FormItem>
            <FormItem label="所属机构">
              <Select v-model="paramsAE.HospitalCode" :label-in-value="true">
                <Option
                  v-for="(item, index) in organList"
                  :value="item.organCode"
                  :key="index"
                  >{{ item.organName }}
                </Option>
              </Select>
            </FormItem>
          </Form>
        </div>
        <div class="btnGroup">
          <Button class="cancel" @click="clear('AE')">重置</Button>
          <Button type="primary" @click="addOrEidt('AE', 'save')">{{
            btnAEname
          }}</Button>
        </div>
      </div>
    </div>
    <Modal
      v-model="showLog"
      title="C-Store SCP服务日志"
      :footer-hide="true"
      :width="1000"
    >
      <log v-if="showLog" @close="showLog = false" :from="'scp'"></log>
    </Modal>
  </div>
</template>
<script>
import log from "./log.vue";
export default {
  components: { log },
  data() {
    return {
      Status: null,
      timer: null,
      baseData: {},
      LogsData: [],
      oldBaseData: {},
      redisIndex: null,
      memoryRedis: null,
      redisPrice: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
      ],
      address: "",
      isOpen: false,
      showLog: false,
      data: {},
      result: {},
      paramsListen: {},
      paramsAE: {},
      columnsOne: [
        { title: "本机IP", key: "IPAddress" },
        { title: "本机端口", key: "Port" },
        { title: "本地AE", key: "AE" },
        {
          title: "操作",
          width: "260px",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.addOrEidt("listen", "edit", params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.delete("listen", params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      columns: [
        { title: "医院编码", key: "HospitalCode" },
        { title: "设备IP", key: "IP" },
        { title: "设备AE", key: "AE" },
        {
          title: "操作",
          width: "260px",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.addOrEidt("AE", "edit", params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                    color: "#3795C8",
                  },
                  on: {
                    click: () => {
                      this.delete("AE", params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      btnName: "新增",
      btnAEname: "新增",
      organList: [],
      status: 10,
    };
  },
  methods: {
    RedisEdit() {
      this.redisIndex = this.memoryRedis;
    },
    redisSet() {
      this.saveData();
    },
    // cancelEdit() {
    //   this.data.RootPath = this.address
    // },
    // editRootUrl() {
    //   if (!this.data.RootPath) {
    //     this.$Message.error("服务基础地址不能为空");
    //   } else {
    //     this.saveData('address')
    //   }
    // },
    changeSwitch(val) {
      this.isOpen = val;
      // this.
      this.$api
        .post("dictionary/updateServiceStatus", {
          serviceSign: this.serviceSign,
          serviceStatus: this.isOpen,
        })
        .then((res) => {
          if (!res) {
            this.isOpen = !this.isOpen;
            this.Status = this.result.serviceStatus;
            this.timer = setInterval(() => {
              this.scpConfig();
            }, 10000);
          } else {
            this.scpConfig();
            this.getOrganList();
          }
        });
      // this.saveData()
    },
    getOrganList() {
      this.$api.get(`organ/GetAllOrganData`).then((rsp) => {
        if (rsp != false) {
          this.organList = rsp.data;
        }
      });
    },
    close() {
      this.showLog = false;
    },
    clear(mode) {
      this.btnName = this.btnAEname = "新增";
      if (mode == "listen") {
        this.paramsListen.IPAddress = "";
        this.paramsListen.Port = "";
        this.paramsListen.AE = "";
      } else {
        this.paramsAE.HospitalCode = "";
        this.paramsAE.IP = "";
        this.paramsAE.AE = "";
      }
      this.scpConfig();
    },
    delete(mode, data) {
      this.$Modal.confirm({
        title: "确认要删除么？",
        mask: false,
        onOk: () => {
          if (mode == "listen") {
            this.data.ListenPortList.splice(data._index, 1);
          } else {
            this.data.AeList.splice(data._index, 1);
          }
          this.saveData(mode);
        },
      });
    },
    addOrEidt(mode, type, data) {
      // console.log(data,899)
      if (mode == "listen") {
        if (type == "edit") {
          this.paramsListen = Object.assign({}, data);
          this.btnName = "保存";
        }
        //不可为空
        if (!this.paramsListen.IPAddress) {
          this.$Message.warning("请输入IP");
          return;
        }
        if (!this.paramsListen.Port) {
          this.$Message.warning("请输入端口");
          return;
        }
        if (!this.paramsListen.AE) {
          this.$Message.warning("请输入AE");
          return;
        }
      } else {
        if (type == "edit") {
          this.paramsAE = Object.assign({}, data);
          this.btnAEname = "保存";
        }
        //不可为空
        if (!this.paramsAE.HospitalCode) {
          this.$Message.warning("请选择机构");
          return;
        }
        if (!this.paramsAE.IP) {
          this.$Message.warning("请输入IP");
          return;
        }
        if (!this.paramsAE.AE) {
          this.$Message.warning("请输入AE");
          return;
        }
      }
      if (type == "save") {
        if (mode == "listen") {
          if (this.btnName == "保存") {
            //编辑状态
            this.data.ListenPortList.splice(this.paramsListen._index, 1);
          }
          // console.log(this.data.ListenPortList);
          // console.log(this.data.ListenPortList);
          this.data.ListenPortList.push(this.paramsListen);
        } else {
          if (this.btnAEname == "保存") {
            //编辑状态
            this.data.AeList.splice(this.paramsAE._index, 1);
          }
          this.data.AeList.push(this.paramsAE);
        }
        this.saveData(mode);
      }
    },
    saveData(mode) {
      this.data.redisIndex = this.redisIndex;
      this.$api
        .post(`ServiceInfo/addOrEditScpConfig`, Object.assign(this.data))
        .then((res) => {
          if (mode == "address") {
            // console.log(mode);
            this.$Message.success("基础地址更新成功");
          } else {
            this.$Message.success(res.msg);
          }
          this.clear(mode);
        });
    },
    scpConfig() {
      this.$api.get(`ServiceInfo/scpConfig`).then((res) => {
        this.serviceSign = res.data.serviceSign;
        this.result = res.data;
        if (this.Status !== res.data.serviceStatus) {
          clearInterval(this.timer);
        }
        this.isOpen = res.data.serviceStatus === 10;
        this.data = Object.assign({}, JSON.parse(res.data.serviceParams));
        this.memoryRedis = this.data.CSRedisInit;
        this.redisIndex = this.data.CSRedisInit;
        // this.address = this.data.RootPath
        // console.log('get------------',res.data);
        // console.log('data',this.data);
      });
    },
    updateScpBaseConfig() {
      this.$api
        .post("ServiceInfo/updateScpBaseConfig", {
          ...this.baseData,
          isPrintSql: this.baseData.isPrintSql == 1 ? true : false,
          // isDesensitization: this.baseData.isDesensitization == 1 ? true : false
          isDesensitization: false,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success("修改成功");
            this.getScpBaseConfig();
          }
        });
    },
    cancelEdit() {
      // console.log(this.oldBaseData,44);
      // this.baseData = this.oldBaseData;
      this. getScpBaseConfig()
    },
    getScpBaseConfig() {
      this.$api.get("ServiceInfo/getScpBaseConfig").then((res) => {
        console.log("----------res---------", res);
        this.baseData = res.data;
        this.baseData.isPrintSql = this.baseData.isPrintSql ? 1 : 0;
        // this.baseData.isDesensitization = this.baseData.isDesensitization ? 1 : 0
        this.oldBaseData = JSON.parse(JSON.stringify(this.baseData));
        console.log("---------data----------", this.baseData);
      });
    },
  },
  created() {
    this.$api.get("dictionary/GetLogConfigurationEnum").then((res) => {
      this.LogsData = res.data;
    });
  },
  mounted() {
    this.LogsData = this.$parent.LogsData;
    this.getScpBaseConfig();
    this.scpConfig();
    this.getOrganList();
  },
};
</script>
<style scoped lang="scss">
.scpPage {
  color: #333;

  .operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .status {
      width: 74px;
      height: 74px;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 50%;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 74px;
      text-align: center;
    }
  }

  .line {
    width: 4px;
    height: 18px;
    background: #338bff;
    margin: 0 8px 0 0;
  }

  .first {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 12px 0;
    height: 32px;
    line-height: 32px;

    .tit {
      display: flex;
      align-items: center;
      font-size: 16px;
    }

    .log {
      width: 82px;
      text-align: center;
      background: #f2f7ff;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #338bff;
      cursor: pointer;
      margin: 0 8px 0 0;
    }
  }

  .des {
    display: flex;
    border: 1px solid #e5e5e5;
    padding: 18px 12px;

    .serDes {
      margin: 0 24px 0 0;
    }

    .secondTit {
      color: #666666;
    }
  }

  .listenList {
    display: flex;

    .tit {
      display: flex;
    }

    .left {
      width: 314px;
      margin: 16px 16px 0 20px;

      .contain {
        border: 1px solid #dcdcdc;
        padding: 12px;
        margin: 12px 0 0 0;
      }

      .btnGroup {
        display: flex;
        justify-content: flex-end;
        margin: 12px 0 16px 0;

        .cancel {
          margin: 0 12px 0 0;
        }
      }
    }

    .right {
      width: calc(100% - 330px);
      margin: 16px 0 0 0;

      .tit {
        margin: 0 0 16px 0;
      }

      .tip {
        font-size: 10px;
        font-weight: 400;
        color: #ff4d4f;
      }
    }
  }
}
/deep/ .ivu-input-number {
  width: 180px;
}
</style>
<style>
.scpPage .ivu-form-item {
  margin-bottom: 12px;
}
</style>